import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LookupComponent, WardInformationComponent, StakeInformationComponent } from '../unit-information';

const routes: Routes = [
  { path: 'units', component: LookupComponent, data: {title: 'Find BYU-Idaho Ward/Stake'} },
  { path: 'units/wards/:campusWardId', component: WardInformationComponent, data: { title: 'Campus Ward'}},
  { path: 'units/stakes/:campusStakeId', component: StakeInformationComponent, data: { title: 'Campus Stake'}}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UnitInformationRoutingModule { }
